import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Breadcrumb from "@/components/Breadcrumb";
import { Toaster } from "@/components/ui/toaster";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Pricing from "@/pages/Pricing";
import Memberships from "@/pages/Memberships";
import Leagues from "@/pages/Leagues";
import Lessons from "@/pages/Lessons";
import Sportsbar from "@/pages/Sportsbar";
import Events from "@/pages/Events";
import Contact from "@/pages/Contact";
import Courses from "@/pages/Courses";
import Menu from "@/pages/Menu";
import GiftCards from "@/pages/GiftCards";
import FAQ from "@/pages/FAQ";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import WhatsNew from "@/pages/WhatsNew";
import Contest from "@/pages/Contest";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Breadcrumb />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/memberships" element={<Memberships />} />
          <Route path="/leagues" element={<Leagues />} />
          <Route path="/lessons" element={<Lessons />} />
          <Route path="/sportsbar" element={<Sportsbar />} />
          <Route path="/events" element={<Events />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/gift-cards" element={<GiftCards />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/whats-new" element={<WhatsNew />} />
          <Route path="/contest" element={<Contest />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
